import React, { useRef, useEffect, useCallback } from 'react';
import BScroll from '@better-scroll/core';
import Wheel from '@better-scroll/wheel';
import './index.less';

BScroll.use(Wheel as any);
export interface PickerDateItem {
  text: string;
  value: any;
}
interface Props {
  pickerDate: any;
  onChange: (value: any, index: number, selectedIndexs: number[]) => void;
  show: boolean;
  selectedIndexs: number[];
  onSure: (value: any) => void;
  name?: string;
  style?: any;
}

const initRef: any = undefined;
export default function(props: Props) {
  const wheelWrap = useRef(initRef);
  const wheel = useRef(initRef);
  const showRef = useRef(initRef);
  // const [selectedIndex, setSelectedIndex] = useState<number[]>([]);

  // show and hide
  const show = useCallback(
    function() {
      if (!wheel.current) {
        wheel.current = props.pickerDate.map((picker, index) => {
          const wrapper = wheelWrap.current.children[index];
          const current = new BScroll(wrapper, {
            wheel: {
              selectedIndex: props.selectedIndexs[index],
              wheelWrapperClass: 'wheel-scroll',
              wheelItemClass: 'wheel-item',
              wheelDisabledItemClass: 'wheel-disabled-item'
            },
            probeType: 3
          });
          current.on('scrollEnd', () => {
            // setSelectedIndex(current.getSelectedIndex());
            props.onChange(
              index,
              current.getSelectedIndex(),
              wheel.current.map(wh => wh.getSelectedIndex())
            );
          });
          return current;
        });
      } else {
        wheel.current.map((wheelItem, index) => {
          wheelItem.enable();
          wheelItem.wheelTo(props.selectedIndexs[index]);
        });
      }
    },
    [props.selectedIndexs, props.pickerDate]
  );


  useEffect(() => {
    showRef.current = show;
  }, [show]);

  function hide() {
    wheel.current && wheel.current.map(wh => wh.disable());
  }

  useEffect(() => {
    console.log(props.pickerDate);
    if (props.show) {
      showRef.current();
    } else {
      hide();
    }
  }, [props.show]);

  // pickerData 更新数据和界面
  useEffect(() => {
    // 更新界面
    wheel.current && wheel.current.map(wh => wh.refresh());
    // setSelectedIndex(props.pickerData.map(() => 0));
  }, [props.pickerDate]);

  // useEffect(() => {
  //   props.onChange(props.pickerData[selectedIndex].value, selectedIndex);
  // }, [selectedIndex]);

  useEffect(() => {
    function handleResize() {
      // 监听屏幕变化，重新刷新让其计算正确高度（在 Android 下，如果 loading 还没完全结束，就打开了，会导致一直沿用原有的 maxScrollY 导致无法滚动的顶部）
      // 因此这里会在屏幕 Resize 的情况下，会重新刷新，500ms 的延时为确保 resize 后界面布局计算完成
      setTimeout(() => {
        wheel.current && wheel.current.map(wh => wh.refresh());
      }, 500);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wheel-content" style={props.style}>
      <div className="mask-top"></div>
      <div className="mask-bottom"></div>
      <div className="wheel-wrap" ref={wheelWrap}>
        {props.pickerDate.map((picker, index) => (
          <div className="wheel" key={index}>
            <ul className="wheel-scroll">
              {picker.map((item: any, k: number) => (
                <li key={k} className="wheel-item" >
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
